var Rest = require('./rest');

var api = function () {
    api.script.apply(api, Array.prototype.slice.call(arguments));
};

api.script = function (api, params, options) {
    var defer = $.Deferred();
    options = $.extend({defaultAlter: true}, options || {});

    $.ajax($.extend({
        url: 'http://act-api.bos.ycgame.com/scripts' + api,
        dataType: 'jsonp',
        data: params,
        timeout:10000
    }, options)).done(function (result) {
        if (result.status >= 200 && result.status < 300) {
            var data = result.data;
            defer.resolve(data);
            return ;
        } else if (result.status) {
            options.defaultAlter && alert("错误("+result.status+")：" + result.detail);
        } else {
            options.defaultAlter && alert('未知错误');
        }

        defer.reject(result);
    }).fail(function (response, text) {
        if (response.status >= 500) {
            options.defaultAlter && alert('系统错误，请稍后在试！错误码：' + response.status);
        } else {
            options.defaultAlter && alert('未知错误，错误码：' + response.status + ', ' + text);
        }
        defer.reject(response);
    }).always(defer.reject);

    return defer;
};

var restObjs = {};
api.rest = function (url, failAlert) {
    if (!restObjs[url]) {
        restObjs[url] = new Rest(url);
    }

    if (failAlert !== undefined) {
        restObjs[url].setFailAlert(failAlert);
    }

    return restObjs[url];
};

api.Rest = Rest;

module.exports = api;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@ycgame/fetch-act-api/src/index.js
// module id = 5
// module chunks = 1